import { render, staticRenderFns } from "./coupon-exchange.vue?vue&type=template&id=31f34090&scoped=true&"
import script from "./coupon-exchange.vue?vue&type=script&lang=js&"
export * from "./coupon-exchange.vue?vue&type=script&lang=js&"
import style0 from "./coupon-exchange.vue?vue&type=style&index=0&id=31f34090&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f34090",
  null
  
)

export default component.exports